import { Component, OnInit, Input} from '@angular/core';
import { ThemeService } from 'src/app/shared/services/theme.service';
import { IThemeColors } from 'src/app/shared/models/interfaces';
import { Subscription } from 'rxjs';
import { ThemeName } from 'src/app/shared/models/themes';
interface IColorOption {
  name : string,
  value : string
}

@Component({
  selector: 'app-user-theme-config',
  templateUrl: './user-theme-config.component.html',
  styleUrls: ['./user-theme-config.component.scss', './../components-conf.scss']
})
export class UserThemeConfigComponent implements OnInit {
  private subscriptions = new Subscription();
  @Input() filterOptionsBy : string = ""

  public themeNames = ThemeName;

  public themeSelected : ThemeName;
  public colorsTheme : IColorOption[] = [];

  public themeOptions : any[] = [];

  public primaryColor : string | undefined;

  constructor(
    private themeService : ThemeService
  ) { 
    const currentThemeSub = this.themeService.getCurrentTheme().subscribe(theme => {
      this.primaryColor = this.themeService.getPrimaryColorFromTheme();
    });

    const themeCollectionSub = this.themeService.themeCollection$.subscribe(theme => {
      this.themeOptions = this.themeService.getThemeOptions();
    });

    this.themeSelected = this.themeService.currentThemeSubject.value;

    this.subscriptions.add(currentThemeSub);
    this.subscriptions.add(themeCollectionSub);
  }

  ngOnInit(): void {
  }

  public selectTheme() {
    this.themeService.selectTheme(this.themeSelected)
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  getColors(theme: IThemeColors) : IColorOption[] {
    return Object.keys(theme).map(key => ({
      name: key,
      value: theme[key as keyof IThemeColors]
    }));
  }

  copyColor(colorValue: string) : void {
    const el = document.createElement('textarea');
    el.value = colorValue;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    alert(`Color ${colorValue} copiado al portapapeles`);
  }
  
  changePrimaryColor() {
    if(!this.primaryColor) return;
    this.themeService.selectPrimaryColor(this.primaryColor)
  }

}
